import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiClient } from '@/services/api';
import type { LeagueStandingsResponse } from '@/types/league';

/**
 * A league's stored table(s). Every league tab that needs the table calls this
 * hook, so they share one cache entry and one request.
 */
export function useLeagueStandings(leagueId: string) {
  return useQuery<LeagueStandingsResponse>({
    queryKey: ['league-standings', leagueId],
    queryFn: async () => (await apiClient.getLeagueStandings(leagueId)).data.data,
    enabled: !!leagueId,
    placeholderData: keepPreviousData,
  });
}
